import { IFeatureFlags } from 'types';

export const test: IFeatureFlags = {};

Object.freeze(test);
